module.exports = __webpack_public_path__ + "static/media/best-time-es.adbfca32.png";